import { render, staticRenderFns } from "./TagInput.vue?vue&type=template&id=fae7e678&scoped=true&lang=pug"
import script from "./TagInput.vue?vue&type=script&lang=ts"
export * from "./TagInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae7e678",
  null
  
)

export default component.exports